import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import CustomSelect from "../../component/CustomSelect";

const caseEditEndpoint = ApiEndpoints.caseStudy.caseEdit;
const caseUpdateEndpoint = ApiEndpoints.caseStudy.caseUpdate;

export default function EditCasestudy() {
  const navigate = useNavigate();
  const { casestudy_id } = useParams();

  const [previews, setPreviews] = useState({ thumbnail: null, banner_image: null, });

  const [postData, setPostData] = useState({ title: "", slug: "", author_id: "", tag_id: "", brief: "", description1: "", description2: "", quotes: "", date: new Date(), thumbnail: null, alt_thumbnail: "", banner_image: null, alt_banner_image: "", });

  const [data, setData] = useState({
    casestudy: {},
    authors: [],
    tags: [],
  });

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", caseEditEndpoint + casestudy_id);
      const result = response;
      setPostData(result.casestudy);
      setData(result);

      // 4️⃣ previews
      setPreviews(prev => ({
        ...prev,
        thumbnail: result.casestudy.thumbnail ? BaseUrl + result.casestudy.thumbnail : prev.thumbnail,
        banner_image: result.casestudy.banner_image ? BaseUrl + result.casestudy.banner_image : prev.banner_image,
      }));

    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    if (casestudy_id) {
      dataFetch();
    }
  }, [casestudy_id]);



  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };


  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // optional fields
    const optionalFields = [];

    const isEmpty = (val) => {
      if (val === null || val === undefined) return true;
      if (typeof val === "string") {
        const cleaned = val.replace(/<[^>]*>/g, "").trim();
        return cleaned === "";
      }
      return val === "";
    };

  for (const [key, value] of Object.entries(postData)) {
    if (!optionalFields.includes(key) && isEmpty(value)) {
      toast.error(`The field "${key}" is mandatory.`);
      return;
    }
  }

  const formData = new FormData();
  Object.entries(postData).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    const response = await ApiRequest("POST", caseUpdateEndpoint + casestudy_id, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success(response.message);
    navigate("/case-study");
  } catch (error) {
    console.error("Error submitting form:", error);
  }
};

const pagename = {
  name: 'Case Study Management',
  user: 'Admin',
  innerpage: 'Case Study Management / Case Study / Edit Case Study'
}


return (
  <>
    <AdminHeader pagename={pagename} />
    <div className="add-content-page">
      <form id="caseEdit" onSubmit={handleSubmit}>

        <div className="add-content-wrap">
          <div className="row">

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>title<small>*</small></label>
                </div>
                <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>slug<small>*</small></label>
                </div>
                <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Tags<small>*</small></label>
                </div>
                <CustomSelect defaultValue={postData?.tag_id} multiple onChange={handleChange} name={"tag_id"} options={data?.tags} placeholder="Select Tags" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Date<small>*</small></label>
                </div>
                <input value={postData?.date ? new Date(postData.date).toISOString().split("T")[0] : ""} onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Author Name" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Author Name<small>*</small></label>
                </div>
                <CustomSelect defaultValue={postData?.author_id} onChange={handleChange} name="author_id" options={data?.authors} placeholder="Select Author Name" />
              </div>
            </div>

          </div>
        </div>

        <div className="add-content-wrap">
          <div className="row">
            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Short Description<small>*</small></label>
                </div>
                <input value={postData?.brief} onChange={handleChange} name="brief" type="text" className="form-control" placeholder="Short Description" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>quotes<small>*</small></label>
                </div>
                <input value={postData?.quotes} onChange={handleChange} name="quotes" type="text" className="form-control" placeholder="Enter Quote" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label> Content 1 Description<small>*</small></label>
                </div>
                <DynamicCKEditor data={postData?.description1} onChange={(event, editor) => handleEditorChange("description1", editor.getData())} />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label> Content 2 Description<small>*</small></label>
                </div>
                <DynamicCKEditor data={postData?.description2} onChange={(event, editor) => handleEditorChange("description2", editor.getData())} />
              </div>
            </div>
          </div>
        </div>

        <div className="add-content-wrap">
          <div className="row">
            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Banner Image Alt Tag<small>*</small></label>
                </div>
                <input value={postData?.alt_banner_image} onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="alt banner" />
              </div>

              <div className="add-page-inputs input-add-image">
                <div className="label-wrap-add">
                  <label>Banner Image (1920 × 600)<small>*</small></label>
                </div>
                <CustomImageUpload name="banner_image"
                  // maxSize={100 * 1024} // 320KB
                  acceptedFormats={[".webp"]}
                  onImageChange={handleChange}
                  imagePreview={previews?.banner_image}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Thumbnail Image Alt Tag<small>*</small></label>
                </div>
                <input value={postData?.alt_thumbnail} onChange={handleChange} name="alt_thumbnail" type="text" className="form-control" placeholder="alt thumbnail" />
              </div>

              <div className="add-page-inputs input-add-image">
                <div className="label-wrap-add">
                  <label>Thumbnail Image (350 × 318)<small>*</small></label>
                </div>
                <CustomImageUpload name="thumbnail"
                  // maxSize={550 * 1024}
                  acceptedFormats={[".webp"]}
                  onImageChange={handleChange}
                  imagePreview={previews.thumbnail} />
              </div>
            </div>
          </div>
        </div>
      </form>
      <button type="submit" form="caseEdit" className="default-btn">publish <span></span></button>
    </div>
  </>
);
}
